// src/components/ProductCard.jsx
import React from 'react';
import PropTypes from 'prop-types';

// Simple formatter for currency
const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(price);
};

const ProductCard = ({ product }) => {
    if (!product) return null;

    const handleTagClick = (tag) => {
        // Optional: Implement filtering by setting URL hash, similar to blog
        console.log(`Tag clicked: ${tag}`);
    };

    return (
        // Reuse post card styling
        <div className="post post-card" role="listitem">
            {product.imageUrl && (
                <img
                    src={product.imageUrl}
                    alt={product.name}
                    style={{
                        width: '100%',
                        aspectRatio: '1 / 1', // Make it square
                        objectFit: 'cover',    // Ensure image covers the square area
                        borderRadius: '16px 16px 0 0', // Increase rounding (adjust value as needed)
                        marginBottom: '1rem'
                    }}
                    loading="lazy"
                />
            )}

            {/* Reuse post-meta structure for product info*/}
            <div className="post-meta" style={{ padding: '0 1.5rem 1.5rem' }}>
                <h2 className="post-title" style={{ marginBottom: '0.5rem' }}>
                    {product.name}
                </h2>

                {/* Description */}
                <p style={{ fontSize: '0.95rem', color: '#555', marginBottom: '1rem' }}>
                    {product.description}
                </p>

                {/* Price */}
                <p style={{ fontSize: '1.1rem', fontWeight: '600', color: '#333', marginBottom: '1rem' }}>
                    {formatPrice(product.price)}
                </p>

                {/* Tags */}
                {Array.isArray(product.tags) && product.tags.length > 0 && (
                    <div className="post-tags" style={{ marginBottom: '1.5rem' }}>
                        {product.tags.map((tag) => (
                            <span
                                key={tag}
                                className="tag-badge clickable" // Reuse tag badge style
                                onClick={() => handleTagClick(tag)}
                                style={{ cursor: 'pointer' }} // Make sure cursor indicates clickability
                            >
                         #{tag}
                    </span>
                        ))}
                    </div>
                )}

                {/* Placeholder for Action Button */}
                <div style={{ textAlign: 'right' }}>
                    <button className="more-button"> {/* Reuse button style*/}
                        View Details {/* Or "Add to Cart" - functionality later */}
                    </button>
                </div>
            </div>
        </div>
    );
};

ProductCard.propTypes = {
    product: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        description: PropTypes.string,
        price: PropTypes.number.isRequired,
        imageUrl: PropTypes.string,
        tags: PropTypes.arrayOf(PropTypes.string),
        type: PropTypes.string,
    }).isRequired,
};

export default ProductCard;